module.exports = __webpack_public_path__ + "img/about-company-01.38b47856.png";